import { useState } from 'react';
import { Card, Col} from 'react-bootstrap';
import PasswordForm from './components/PasswordForm';
import { ChangePasswordService } from '@services/change-password/ChangePasswordService';
import { showMessage } from '../createV3/layerStore';
import showAlert from 'src/shared/utils/generic';
import Message from 'src/components/common/Message';
import Loader from 'src/components/common/loader/loader';
import Pageheader from 'src/components/pageheader/pageheader';

export default function ChangePasswordExternal() {
    const [isLoading, setIsLoading] = useState(false);

    const sendFormData = async (password: string) => {
        try {
            setIsLoading(true);
            const service = new ChangePasswordService();
            await service.changePassword(password);
            showAlert("Password changed successfully", "success", 5000);
        } catch(error: any){
            showMessage(error.message, "error", 5000);
        } finally {
            setIsLoading(false);
        }
    }
   
    return(
        <div className="px-3">
            <Pageheader
                title="Change Password"
                heading=""
                active=""
            />
            <Card className="custom-card">
                {isLoading && <Loader />}
                <Card.Body>
                    <Col className="col-6 mx-auto">
                        <PasswordForm sendFormData={sendFormData} />
                    </Col>
                </Card.Body>
            </Card>
            <Message />
        </div>
    )
}